import type { SiteSummaryEntry } from "#/types/report";
import { EmptyState } from "#/components/ui/EmptyState";
import { BarChart } from "@mantine/charts";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import ReportSection from "./ReportSection";

interface ItemsBySiteChartProps {
  siteSummary: SiteSummaryEntry[];
  tooltip?: ReactNode;
}

const ItemsBySiteChart = ({ siteSummary, tooltip }: ItemsBySiteChartProps) => {
  const { t } = useTranslation();

  const hasData = siteSummary.length > 0;
  const chartData = siteSummary.map((site) => ({
    site: site.siteName,
    items: site.itemCount,
  }));

  return (
    <ReportSection title={t("reports.inventoryScan.itemsBySite.title")} tooltip={tooltip}>
      {!hasData ? (
        <div className="flex h-48 items-center justify-center">
          <EmptyState title={t("common.noData")} />
        </div>
      ) : (
        <BarChart
          h={280}
          data={chartData}
          dataKey="site"
          series={[{ name: "items", color: "blue.5" }]}
          tickLine="y"
          gridAxis="y"
        />
      )}
    </ReportSection>
  );
};

export default ItemsBySiteChart;
